module.exports = __webpack_public_path__ + "media/images/logo-cf786831a02761c963c8efc33ecb578c.png";